"use client";

import { SignupLayout } from "@/components/domain/signup/SignupLayout";
import type { Step } from "@/components/domain/signup/SignupStepBar";
import { useState } from "react";
import { EmailAlreadyRegisteredView } from "./EmailAlreadyRegisteredView";
import { OtpForm } from "./OtpForm";
import { SignupForm } from "./SignupForm";

type SignupSectionState = "form" | "emailAlreadyRegistered" | "otpSent";

export const SignupSection = () => {
  const [state, setState] = useState<SignupSectionState>("form");
  const [email, setEmail] = useState("");

  const currentStep: Step = state === "otpSent" ? 2 : 1;

  return (
    <SignupLayout
      currentStep={currentStep}
      showHeroSection={state !== "otpSent"}
    >
      {state === "form" ? (
        <SignupForm
          onCompleteSubmit={(submittedEmail) => {
            setEmail(submittedEmail);
            setState("otpSent");
          }}
          onEmailAlreadyRegistered={() => setState("emailAlreadyRegistered")}
        />
      ) : state === "emailAlreadyRegistered" ? (
        <EmailAlreadyRegisteredView onBack={() => setState("form")} />
      ) : (
        <OtpForm
          email={email}
          onCodeVerifierError={() => setState("form")}
          onBack={() => setState("form")}
        />
      )}
    </SignupLayout>
  );
};
